import { Component, OnInit,Input,EventEmitter,Output } from '@angular/core';
import { LoggedinService } from '../../../services/login/loggedin.service';
import { User } from '../../../models/login/login';
import { SessionHelper } from '../../../shared/services/localstorage';
import { SpeakerListService } from '../../../services/speaker/speaker-list/speaker-list.service';
import { roleID } from '../../../configurations/configuration';
import { Observable } from 'rxjs';
import { SpeakerTypeService } from '../../../services/speaker/speaker-type/speaker-type.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseService } from '../../../services/base/base.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material';
import { DeleteSpeakerService } from '../../../services/speaker/delete-speaker/delete-speaker.service';
import { ConfirmationDialog } from '../../../shared/confirm-dialog/confirmation-dialog';
import { GlobalService } from '../../../services/global/global.service';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { noVenueID } from '../../../configurations/configuration';

const ELEMENT_DATA = [
  { S: 1, M: 2, T: 3, W: 4, TH: 1, F: 2, SA: 3 },

];

@Component({
  selector: 'app-speaker-list',
  templateUrl: './speaker-list.component.html',
  styleUrls: ['./speaker-list.component.scss'],
  providers: [
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE,MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true }}
  ]
})
export class SpeakerListComponent implements OnInit {
  @Input() eventsSubject: Observable<void>;
  role: number;
  user: User;
  speakerData = [];
  states:any=[];
  roleID = roleID;
  speakerFilterForm: FormGroup;
  scopeBrandId : number;
  _topicId: any;
  _event_start_date:any;
  pageSize: number = 10;
  pageNumber: number = 1;
  totalRecords: number;
  speakerAvailFilter: any={};
  isSearch: boolean = false;
  @Input() pageSource: string;
  @Input() brandId: string;
  @Input() eventId;
  @Output() pickForMeEvent = new EventEmitter<string>();
  // @Input() topicId: string;  
  // @Input() eventStartDate: string;

  @Input() set eventStartDate(value: any) {
    console.log(">>>>>>>>>>>>>>>TEST GET SET")
    this._event_start_date = value;
    // if(this.pageSource)
    // this.eventsSubscription = this._events.subscribe(() => this.getSpeakerAvailability())
    // this.getSpeakerAvailability(this._topicId)

    this.speakerAvailFilter.eventStartDate = this._event_start_date;
    this.speakerAvailFilter.topicId = this.topicId;
    this.speakerAvailFilter.brandId = this.brandId;

    this.speakerListService.getAllSpeakerByAvailability(this.speakerAvailFilter).subscribe((result: any) => {
      console.log(result);
      if(result.status) {
        this.pageNumber = 1;
        this.speakerData = result.data.data;
        console.log("this.speakerData",this.speakerData);
        for( let i =0 ;i<this.speakerData.length ; i ++){

          if(this.speakerData[i].treatmentStartDate == '0000-00-00 00:00:00'){
            this.speakerData[i].treatmentStartDate  = null;
          }
          if(this.speakerData[i].treatmenEndDate == '0000-00-00 00:00:00'){
            this.speakerData[i].treatmenEndDate  = null;
          }
          
        }
        this.totalRecords = result && result.data.data ? result.data.data.length: 0;
        if(this.speakerData && this.speakerData.length > 0) {
          this.searchMessage = '';
        }
        
        else if(this.speakerData && this.speakerData.length == 0){
          this.searchMessage = "No Speaker matches your search criteria, please retry you search with different attributes.";
        }
      }
    })       


  }
  get eventStartDate(): any {
    return this._event_start_date;
  }


  @Input() set topicId(value: any) {
    console.log(">>>>>>>>>>>>>>>TEST GET SET")
    this._topicId = value;
    // if(this.pageSource)
    // this.eventsSubscription = this._events.subscribe(() => this.getSpeakerAvailability())
    // this.getSpeakerAvailability(this._topicId)

    this.speakerAvailFilter.eventStartDate = this.eventStartDate;
    this.speakerAvailFilter.topicId = this._topicId;
    this.speakerAvailFilter.brandId = this.brandId;

    this.speakerListService.getAllSpeakerByAvailability(this.speakerAvailFilter).subscribe((result: any) => {
      console.log(result);
      if(result.status) {
        this.speakerData = result.data.data;
        this.totalRecords = result && result.data.data ? result.data.data.length: 0;
        if(this.speakerData && this.speakerData.length > 0) {
          this.searchMessage = '';
        }
        else if(this.speakerData.length == 0) {
          this.searchMessage = "No Speaker matches your search criteria, please retry you search with different attributes.";
        }
      }
    })       


  }
  get topicId(): any {
    return this._topicId;
  }
  filterObj = {};
  filterObjSpeaker:any={};
  filter=false;
  private eventsSubscription: any
  includedFields: any={};
  
  speakerObj = [];
  showLoader: boolean = false;
  key='';
  searchMessage = "";
  noRecordsMsg = '';
  @Output() messageEvent = new EventEmitter<string>();

  constructor(private speakerTypeService: SpeakerTypeService,
    private fb:FormBuilder,
    public baseService:BaseService,
    public loggedInService: LoggedinService, 
    private speakerListService: SpeakerListService,
    private deleteSpeakerService: DeleteSpeakerService, 
    private dialog: MatDialog, 
    private globalService: GlobalService) { }

 
  displayedColumns: string[] = ['Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th'];
  dataSource = ELEMENT_DATA;

  ngOnInit() {
    this.getSpeakerType();
    let user = SessionHelper.getSession();
    this.speakerFilterForm = this.fb.group({
      "firstName": [''],
      "lastName": [''],
      "sex": [''],
      "city": [''],
      "stateId": [''],
      "brandId": [user.brand_id],
      "dateOfDiagnosis":[''],
      "treatmentStartDate":[''],
      "biography":[''],
      "speakerTypeId":[''],
      "preferred":['']
    });
    this.getAllStates();
    if(SessionHelper.isLoggedIn()) {
      this.loggedInService.changeStatus(true);
    }
    else {
      this.loggedInService.changeStatus(false);
    }
   
    console.log("user",user);
    this.role = user.role_id;
    this.scopeBrandId = user.brand_id;
    this.getSpeaker();
  }

  pickForMeParent() {
    this.pickForMeEvent.next('');
  }

  getAllStates() {
    this.baseService.getAllStates().subscribe((result: any) => {
      console.log(result);
      this.states = result.data;
    },
    err => {
      
    })
  }
  getSpeakerType() {
    this.speakerTypeService.getAllSpeakerTypes().subscribe((result: any) => {
      console.log("speakerType SPeaker Type", result);
      if(result.status) {
        // this.speakerType = result.data;
      }
    });
  }

  deleteRecord(id) {

    const dialogRef = this.dialog.open(ConfirmationDialog,{ disableClose: true });
    dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete the Speaker?";


    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        let obj = {
          id: id,
          isActive: 0
        }
        this.speakerData.forEach(element => {
          if(element.id === id) {            
            element.isLoader = true;
          }
        });
        this.deleteSpeakerService.deleteSpeaker(obj).subscribe((result: any) => {
          console.log(result)
          if(result.status) {
            this.speakerData.forEach((element, index) => {
              if ( element.id === id) {
                this.showLoader = false;
                this.getSpeaker();
              }
            });
          }
        });

      }
    });

  
  }

  pageChanged(pN: number): void {
    this.pageNumber = pN;
  }


  public SalesRepCheck = () => {
  }

  onSearch(){
    this.noRecordsMsg = '';
    this.includedFields={
      "keyword":this.key,
      "brandId":this.scopeBrandId
    }
    console.log("key",this.key);
    this.speakerListService.getAllSpeaker(this.includedFields).subscribe((result: any) => {
      console.log(result);
      if(result.status) {
        this.speakerData = result.data.data;
        this.totalRecords = result && result.data.data ? result.data.data.length: 0;
        if(this.speakerData && this.speakerData.length > 0) {
          this.searchMessage = '';
        }
        else if(this.speakerData.length == 0) {
          this.searchMessage = "No Speaker matches your search criteria, please retry you search with different attributes.";
        }
      }
    })
  }
  selectSpeaker(speakerObj){
    console.log(speakerObj);
    this.messageEvent.emit(speakerObj)
    window.scrollTo(0, 350);
  }


  getSpeakerAvailabilityFilter(){
    this.getSpeakerAvailability()
  }


  getSpeakerAvailability(){
    this.noRecordsMsg = '';
    this.pageNumber = 1;
    this.speakerAvailFilter = this.globalService.filterEmptyFields(this.speakerFilterForm.value);
    this.speakerAvailFilter.eventStartDate = this.eventStartDate;
    this.speakerAvailFilter.topicId = this.topicId;

    this.speakerAvailFilter.brandId = this.scopeBrandId;
    this.speakerListService.getAllSpeakerByAvailability(this.speakerAvailFilter).subscribe((result: any) => {
      console.log(result);
      if(result.status) {
        this.speakerData = result.data.data;
        this.totalRecords = result && result.data.data ? result.data.data.length: 0;
        for( let i =0 ;i<this.speakerData.length ; i ++){

          if(this.speakerData[i].treatmentStartDate == '0000-00-00 00:00:00'){
            this.speakerData[i].treatmentStartDate  = null;
          }
          if(this.speakerData[i].treatmenEndDate == '0000-00-00 00:00:00'){
            this.speakerData[i].treatmenEndDate  = null;
          }
          
        }
        if(this.speakerData && this.speakerData.length > 0) {
          this.searchMessage = '';
        }
        else if(this.speakerData.length == 0){
          this.searchMessage = "No Speaker matches your search criteria, please retry your search with different attributes.";
        }
      }
    })    
  }


  getSpeakerFilter(){
    this.filter=true;
    this.isSearch = true;
    this.getSpeaker()
  }

  getSpeaker() {
    this.noRecordsMsg = '';
    this.searchMessage = '';
    console.log(this.filter);
    if(this.filter = true){
      this.includedFields = this.globalService.filterEmptyFields(this.speakerFilterForm.value);
      console.log("----------------------------", this.includedFields);
      this.includedFields.brandId = this.scopeBrandId;
    }else{
      this.includedFields.brandId=this.brandId;
      console.log("----------------------------", this.scopeBrandId)
    }
    this.filter=false;
   
    console.log("speakerFilterFormVALUE",this.scopeBrandId)
    console.log(">>>>>>>>>>>>>",this.pageSource);
    if(!this.pageSource)
      this.speakerListService.getAllSpeaker(this.includedFields).subscribe((result: any) => {
        console.log(result);
        if(result.status) {    
          // result.data.data.forEach(element => {
          //   element['treatmentStartDate'] = moment(element.treatmentStartDate, "YYYY-MM-DD").format("MM-DD-YYYY");
          //   element['treatmenEndDate'] = moment(element.treatmenEndDate, "YYYY-MM-DD").format("MM-DD-YYYY");
          // });
          this.speakerData = result.data.data;

          console.log("speakerData>>>>",this.speakerData);
          for( let i =0 ;i<this.speakerData.length ; i ++){

            if(this.speakerData[i].treatmentStartDate == '0000-00-00 00:00:00'){
              this.speakerData[i].treatmentStartDate  = null;
            }
            if(this.speakerData[i].treatmenEndDate == '0000-00-00 00:00:00'){
              this.speakerData[i].treatmenEndDate  = null;
            }
            
          }
          // if( this.speakerObj.careGiverDob == '0000-00-00'){
          //   const careGiverDobControl = this.editSpeakerForm.get('careGiverDob');
          //   careGiverDobControl.setValidators(null);
          //   careGiverDobControl.updateValueAndValidity();
          //  }
          //  if( this.speakerObj.patientDateOfDiagnosis == '0000-00-00 00:00:00'){
          //   this.speakerObj.patientDateOfDiagnosis = null;
          //  }
          //  if( this.speakerObj.patientTreatmentStartDate == '0000-00-00 00:00:00'){
          //   this.speakerObj.patientTreatmentStartDate = null;
          //  }
          this.totalRecords = result && result.data.data ? result.data.data.length: 0;
          if(this.speakerData && this.speakerData.length > 0 && this.isSearch==false) {
            this.noRecordsMsg = ''
          }
          else if(this.speakerData.length <= 0 && this.isSearch==false){
            this.noRecordsMsg = 'No records found';
          }          
          if(this.speakerData && this.speakerData.length > 0 && this.isSearch==true) {
            this.searchMessage = "";
          }
          else if(this.speakerData.length == 0 && this.isSearch==true){
            this.searchMessage = "No Speaker matches your search criteria, please retry your search with different attributes.";
          }
          console.log("Speaker Data --------------",this.speakerData)
        }
      })
    }    
    resetList() {
      this.speakerFilterForm.reset();
      this.key = '';
      if(!this.pageSource) {
        this.getSpeaker();
      }
      else if (this.pageSource =='event') {
        this.getSpeakerAvailability();
      }
    }

  }




